
  import React from "react"
  import Component from "/usr/share/nginx/html/learn-master_ch/src/layouts/index.js"
  import data from "/usr/share/nginx/html/learn-master_ch/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js